import React from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";

const PersonalDetail = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue
 
}) => {
  console.log("🚀 ~ PersonalDetail ~ values:", values);
  return (
    <Form>
      <Row>
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Organization Name
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.name && touched.name ? "is-invalid" : ""
              }`}
              id="name"
              name="name"
              placeholder="Enter your organization name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.name && touched.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="email" className="form-label">
              Email Address
            </Label>
            <Input
              type="email"
              className={`form-control ${
                errors.email && touched.email ? "is-invalid" : ""
              }`}
              id="email"
              name="email"
              placeholder="Enter your email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.email && touched.email && (
              <div className="invalid-feedback">{errors.email}</div>
            )}
          </div>
        </Col>
        {/* <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="tel" className="form-label">
              Telephone Number
            </Label>
            <Input
              type="text"
              className={`form-control ${errors.tel && touched.tel ? 'is-invalid' : ''}`}
              id="tel"
              name="tel"
              placeholder="Enter your telephone number"
              value={values.tel}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.tel && touched.tel && <div className="invalid-feedback">{errors.tel}</div>}
          </div>
        </Col> */}
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="contactNo" className="form-label">
              Contact Number
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.contactNo && touched.contactNo ? "is-invalid" : ""
              }`}
              id="contactNo"
              name="contactNo"
              placeholder="Enter your phone number"
              value={values.contactNo}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.contactNo && touched.contactNo && (
              <div className="invalid-feedback">{errors.contactNo}</div>
            )}
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="website" className="form-label">
              Website
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.website && touched.website ? "is-invalid" : ""
              }`}
              id="website"
              name="website"
              placeholder="www.example.com"
              value={values.website}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.website && touched.website && (
              <div className="invalid-feedback">{errors.website}</div>
            )}
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="address1" className="form-label">
              Address 1
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.address1 && touched.address1 ? "is-invalid" : ""
              }`}
              id="address1"
              name="address1"
              placeholder="Enter your address 1"
              value={values.address1}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.address1 && touched.address1 && (
              <div className="invalid-feedback">{errors.address1}</div>
            )}
          </div>
        </Col>

        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="address2" className="form-label">
              Address 2
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.address2 && touched.address2 ? "is-invalid" : ""
              }`}
              id="address2"
              name="address2"
              placeholder="Enter your address 2"
              value={values.address2}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.address2 && touched.address2 && (
              <div className="invalid-feedback">{errors.address2}</div>
            )}
          </div>
        </Col>

        {/* <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="adminEmail" className="form-label">
              Admin Email
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.adminEmail && touched.adminEmail ? "is-invalid" : ""
              }`}
              id="adminEmail"
              name="adminEmail"
              placeholder="Enter admin email"
              value={values.adminEmail}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.adminEmail && touched.adminEmail && (
              <div className="invalid-feedback">{errors.adminEmail}</div>
            )}
          </div>
        </Col> */}
        <Col lg={6}>
          <div className="mb-3">
            <Label htmlFor="tagLine" className="form-label">
              Tagline
            </Label>
            <textarea
              className={`form-control ${
                errors.tagLine && touched.tagLine ? "is-invalid" : ""
              }`}
              id="tagLine"
              name="tagLine"
              rows="1"
              placeholder="Enter a tagline"
              value={values.tagLine}
              onChange={handleChange}
              onBlur={handleBlur}
            ></textarea>
            {errors.tagLine && touched.tagLine && (
              <div className="invalid-feedback">{errors.tagLine}</div>
            )}
          </div>
        </Col>
        <Col lg={3}>
          
            
          <div className="mb-3">
            <Label htmlFor="vatPercentage" className="form-label">
              VAT Percentage
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.vatPercentage && touched.vatPercentage
                  ? "is-invalid"
                  : ""
               
              }`}
              id="vatPercentage"
              name="vatPercentage"
              placeholder="0"
              value={values.vatPercentage}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.vatPercentage && touched.vatPercentage && (
              <div className="invalid-feedback">{errors.vatPercentage}</div>
            )}
         
          </div>
        </Col>
        <Col lg={3}>
          <div className="mb-3">
           
          <div className="mb-3">
            <Label htmlFor="serviceCharge" className="form-label">
              Service Charge
            </Label>
            <Input
              type="text"
              className={`form-control ${
                errors.serviceCharge && touched.serviceCharge
                  ? "is-invalid"
                  : ""
              
              }`}
              id="serviceChargePercentage"
              name="serviceChargePercentage"
              placeholder="0"
              value={values.serviceChargePercentage}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.serviceChargePercentage &&
              touched.serviceChargePercentage && (
                <div className="invalid-feedback">
                  {errors.serviceChargePercentage}
                </div>
              )}
          </div>
            {errors.serviceChargePercentage &&
              touched.serviceChargePercentage && (
                <div className="invalid-feedback">
                  {errors.serviceChargePercentage}
                </div>
              )}
          </div>
        </Col>

        {/* showBOT */}
        <Col lg={12}>
          <div className="mb-3 pt-4">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                name="disableBotInCutsomer"
                id="disableBotInCutsomer"
                checked={values.disableBotInCutsomer} // boolean
                onChange={(e) =>
                  setFieldValue("disableBotInCutsomer", e.target.checked)
                }
                onBlur={handleBlur}
              />
              <label
                className="form-check-label fs-6 w-full"
                htmlFor="disableBotInCutsomer"
              >
                Disable BOT in customer
              </label>

            </div>

       
          </div>
        </Col>

        <Col lg={12}>
          <div className="mb-3">
            <Label htmlFor="aboutUs" className="form-label">
              About Us
            </Label>
            <textarea
              className={`form-control ${
                errors.aboutUs && touched.aboutUs ? "is-invalid" : ""
              }`}
              id="aboutUs"
              name="aboutUs"
              rows="6"
              placeholder="Write about your organization"
              value={values.aboutUs}
              onChange={handleChange}
              onBlur={handleBlur}
            ></textarea>
            {errors.aboutUs && touched.aboutUs && (
              <div className="invalid-feedback">{errors.aboutUs}</div>
            )}
          </div>
        </Col>
        {/* <Col lg={12}>
          <div className="hstack gap-2 justify-content-end">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
            <button type="button" className="btn btn-soft-success">
              Cancel
            </button>
          </div>
        </Col> */}
      </Row>
    </Form>
  );
};

export default PersonalDetail;
